import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { DepartmentDataPayload, DepartmentDataResponse } from "@/types/interface/department";

export const useDepartmentStore = defineStore("departmentStore", () => {
  const department = ref<DepartmentDataResponse>();
  const departments = ref<DepartmentDataResponse[]>([]);

  function initDepartments(data: any) {
    departments.value = data?.data;
  }

  function addNewDepartment(data: any) {
    department.value = data;
  }

  async function dispatchGetDepartments(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.department.getDepartment(page, limit, queryParam);
      if (status === 200 ) {
        initDepartments(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idDepartment = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.department.findDepartment(idDepartment);
      if (status === 200 ) {
        addNewDepartment(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: DepartmentDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.department.createDepartment(payload);
      if (status === 200 ) {
        addNewDepartment(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idDepartment = "", payload: DepartmentDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.department.updateDepartment(idDepartment, payload);
      if (status === 200 ) {
        addNewDepartment(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idDepartment = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.department.deleteDepartment(idDepartment);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    department,
    departments,
    initDepartments,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetDepartments,
    dispatchDelete
  };
});